export default __webpack_public_path__ + "static/media/ss_sheet.6debfa51.png";